import React from 'react';
import ButtonSearchFilter from '../../../../components/buttons/ButtonSearchFilter';
import { VehicleFilters } from '../../../../app/models/Vehicle';
import { vehicleTypeOptions } from '../../../../app/models/Vehicle';

type Props = {
    filter: VehicleFilters;
    setFilter: (filter: VehicleFilters) => void;
    onSearch: () => void;
};

const VehicleFilter = ({ filter, setFilter, onSearch }: Props) => {
    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="row">
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="patent">
                        Patente
                    </label>
                    <input
                        title="Patente"
                        type="text"
                        id="patent"
                        name="patent"
                        className="form-control form-control-sm"
                        value={filter.patent}
                        onChange={(e) => handlerInputFilter(e)}
                    />
                </div>
            </div>
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="vehicle_type">
                        Tipo
                    </label>
                    <select
                        title="Tipo"
                        id="vehicle_type"
                        name="vehicle_type"
                        className="form-control form-control-sm"
                        value={filter.vehicle_type}
                        onChange={(e) => handlerInputFilter(e)}
                    >
                        <option value="">Todos</option>
                        {vehicleTypeOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="col-md-auto">
                <div style={{ marginTop: '22px' }}>
                    <ButtonSearchFilter callbackSearch={onSearch} />
                </div>
            </div>
        </div>
    );
};

export default VehicleFilter;
